define("calendar/components/calendar/settings/bttp/enable", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <h5 class="u--text--md u--m__t__0">
    {{t (if this.isTiktok this.tiktokUpgradeTitle "bttp.upgrade_title")}}
  </h5>
  <p class="u--text--light">
    {{#if this.upgradeDetails}}
      {{html-safe (t this.upgradeDetails)}}
    {{/if}}
    <Shared::Link @href={{this.learnMoreLink}} @text={{t "shared_phrases.learn_more"}} />
  </p>
  <Shared::Button::Upgrade
    @feature={{if this.isTiktok "tiktokBttp" "bttp"}}
    @location="calendar settings -- best time to post"
    @text={{@upgradeButtonText}}
    @track={{this.track}}
    class="qa--bttp_upgrade_plan_btn"
    data-test-id="bttp-upgrade-plan"
  />
  
  {{#unless @isOnLegacyPlan}}
    <Calendar::Settings::Bttp::InfoCard />
  {{/unless}}
  */
  {
    "id": "LcOUBurw",
    "block": "[[[10,\"h5\"],[14,0,\"u--text--md u--m__t__0\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[52,[30,0,[\"isTiktok\"]],[30,0,[\"tiktokUpgradeTitle\"]],\"bttp.upgrade_title\"]],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n\"],[41,[30,0,[\"upgradeDetails\"]],[[[1,\"    \"],[1,[28,[35,2],[[28,[37,0],[[30,0,[\"upgradeDetails\"]]],null]],null]],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,3],null,[[\"@href\",\"@text\"],[[30,0,[\"learnMoreLink\"]],[28,[37,0],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\"],[8,[39,4],[[24,0,\"qa--bttp_upgrade_plan_btn\"],[24,\"data-test-id\",\"bttp-upgrade-plan\"]],[[\"@feature\",\"@location\",\"@text\",\"@track\"],[[52,[30,0,[\"isTiktok\"]],\"tiktokBttp\",\"bttp\"],\"calendar settings -- best time to post\",[30,1],[30,0,[\"track\"]]]],null],[1,\"\\n\\n\"],[41,[51,[30,2]],[[[1,\"  \"],[8,[39,6],null,null,null],[1,\"\\n\"]],[]],null]],[\"@upgradeButtonText\",\"@isOnLegacyPlan\"],false,[\"t\",\"if\",\"html-safe\",\"shared/link\",\"shared/button/upgrade\",\"unless\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/enable.hbs",
    "isStrictMode": false
  });
  let EnableComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class EnableComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "segment", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "bttp", _descriptor4, this);
    }
    get isEligibleForTrial() {
      return this.subscriptions.isEligibleForTrial;
    }
    get isTiktok() {
      return Boolean(this.selectedSocialProfiles.firstProfile?.isTiktok);
    }
    get isFacebook() {
      return Boolean(this.selectedSocialProfiles?.firstProfile?.isFacebook);
    }
    get isInstagram() {
      return Boolean(this.selectedSocialProfiles?.firstProfile?.isInstagram);
    }
    get tiktokUpgradeTitle() {
      return this.isEligibleForTrial ? 'bttp.tiktok.trial_upgrade_title' : 'bttp.tiktok.upgrade_title';
    }
    get learnMoreLink() {
      return this.bttp.learnMoreLink(this.selectedSocialProfiles.firstProfile?.profileType);
    }
    get upgradeDetails() {
      if (this.isTiktok) {
        return 'bttp.tiktok.upgrade_details';
      } else if (this.isFacebook) {
        return 'bttp.facebook_upgrade_details';
      } else if (this.isInstagram) {
        return 'bttp.instagram_upgrade_details';
      }
      return undefined;
    }
    track() {
      const payload = {
        social_profile_handle: this.selectedSocialProfiles.firstProfile?.nickname || '',
        active_trial: Boolean(this.subscriptions.hasActiveTrial)
      };
      if (this.isEligibleForTrial) {
        this.segment.track('opted-in-for-trial-calendar-settings', payload);
      } else {
        this.segment.track('clicked-upgrade-button-calendar-settings', payload);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "track", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "track"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EnableComponent);
});